<template>
  <div class="my_radio_layer">
    <div class="func_panel_item_wrap">
      <p class="left_icon">
        <slot name="icon"></slot>
      </p>
      <span class="panel_item_title" :style="{ width: titleWidth + 'px' }">{{ title }}</span>
      <p class="panel_item_content">
        <el-radio-group v-model="selectValue">
          <el-radio label="show" :disabled="disabled">{{$t('view_form_dialog_add_form_213')}}</el-radio>
          <el-radio label="hide" :disabled="disabled">{{$t('view_back_top_index_105')}}</el-radio>
        </el-radio-group>
      </p>
    </div>
    <slot name="expand" v-if="selectValue === 'show'">
    </slot>
  </div>
</template>

<script>
import i18n from '../../../../language/index'

  export default {
    name:'my_radio',
    props:{
      value: {
        type: String,
        required: true
      },
      title: {  // 组件的标题
        type: String,
        default: ''
      },
      titleWidth: { // 标题宽度
        type: String,
        default: '40'
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      value (val) {
        this.selectValue = val
      },
      selectValue (val) {
        this.$emit('input', val)
      }
    },
    data(){
      return {
        selectValue: this.value
      }
    }
  }
</script>

<style lang="scss" scoped>
  .my_radio_layer {
    position: relative;
    .left_icon {
      /*display: inline-block;*/
      /*font-size: 13px;*/
      /*text-align: right;*/
      /*overflow: hidden;*/
      height: 32px;
      line-height: 32px;
      position: absolute;
      margin-left: -20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/left_sidebar/page_setting/components/my_radio.vue